var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Profile_-_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - Profile - Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-3{fill:none;stroke-linecap:round;stroke-width:2px;stroke:#0baf50;stroke-miterlimit:10}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Profile_-_Selected-2",
    "data-name": "Icon - Profile - Selected",
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h14v16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3614",
    "data-name": "Group 3614",
    transform: "translate(.778 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_129",
    fill: "none",
    stroke: "#fed148",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L12 0",
    "data-name": "Line 129",
    transform: "translate(0 14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6229",
    d: "M2 17.344a6.313 6.313 0 0 1 6.222-6.4 6.313 6.313 0 0 1 6.222 6.4",
    className: "prefix__cls-3",
    "data-name": "Path 6229",
    transform: "translate(-2 -2.944)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_764",
    cx: 3.889,
    cy: 4,
    className: "prefix__cls-3",
    "data-name": "Ellipse 764",
    rx: 3.889,
    ry: 4,
    transform: "translate(2.333)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileSelected);
export default __webpack_public_path__ + "static/media/icon-profile-selected.70d706eedadd50397c97beffa0c46dd0.svg";
export { ForwardRef as ReactComponent };